import React, { lazy } from 'react'
import "./zartecbutton.css"
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import img1 from '../Components/Images/Barcode/BD2.png'
import img2 from '../Components/Images/Barcode/BD3.png'
import img3 from '../Components/Images/Barcode/BD4.png'
import img4 from '../Components/Images/Barcode/BD5.png'
import img5 from '../Components/Images/Barcode/BD6.png'
import img6 from '../Components/Images/Barcode/BM2.png'
import img7 from '../Components/Images/Barcode/BM3.png'
import img8 from '../Components/Images/Barcode/BM4.png'
import img9 from '../Components/Images/Barcode/BI2.png'
import img10 from '../Components/Images/Barcode/BI3.png'
import img11 from '../Components/Images/Barcode/BI4.png'


function BarcodePrinters() {
  const productDesktop=[
    {
    id:1,
    category:"ZD200 Series - Zebra",
    model:"ZD200",
    description: "Not all printers are created equally, especially value models. Instead of cutting corners to reduce costs, the ZD200 Series desktop printers are engineered with Zebra quality to deliver reliable operation at an affordable price. ",
    image: img1
  },
  {
    id:2,
    category:"ZD 510 - HC Wristband - Zebra",
    model:"ZD200",
    description: "The ZD510-HC wristband printing solution combines the reliable ZD510-HC direct thermal printer with easy-to-load cartridges containing the only antimicrobial-coated wristbands on the market. Also printing wristbands for amusement water park ",
    image: img2
  },
  {
    id:3,
    category:"ZD 600 Series - Zebra",
    model:"ZD200",
    description: "The ZD600 desktop printers build on the legacy of the industry-leading GX Series and are available in thermal transfer, direct thermal, healthcare, and RFID models. These premium printers bring industrial printing quality to a compact desktop printer.",
    image: img3
  },
  {
    id:4,
    category:"PC 45D - Honeywell",
    model:"ZD200",
    description: "The PC45D 4-inch direct thermal printer offers a large touchscreen, enterprise-level ruggedness, and optimized low label and low ribbon warning workflows to predict and reduce downtime. ",
    image: img4
  },
  {
    id:5,
    category:"PC 42E-T",
    model:"ZD200",
    description: "The PC42E-T desktop printer is compact, reliable, and providing efficient printing performance, easy manageability, and maintenance with its features and user-friendly design.",
    image: img5
  }
];

const productMobile =[
  {
    id:1,
    category:"MPD 31D",
    description:"The MPD31D is a light weight mobile printer with best in-class performance and economical price. It can be used in manufactory, warehouse, logistics, retail, public utilities and healthcare, healthcare.",
    image:img6
  },
  {
    id:2,
    category:"RP4F",
    description:"The RPf Series mobile thermal printers are built for the most rugged environments, offering exceptional media and battery capacity, and excellent value to help operations increase efficiency and minimize downtime.",
    image:img7
  },
  {
    id:3,
    category:"ZQ Plus Series",
    description:"The ZQ600 Plus Series takes the popular QLn platform and makes it even better–adding advanced technology and innovative design that drive productivity, ease of use, and manageability to a new level.",
    image:img8
  },
]

const productIndustrial =[
  {
    id:1,
    category:"ZT510 series - Zebra",
    description:"Designed to strike the ideal balance between performance and value, the ZT510 includes the core features you need in an industrial printer at a cost-effective price point.",
    image:img9
  },
  {
    id:2,
    category:"ZT100 series - Zebra",
    description:"Are your printing needs growing, but your budget is limited? No problem. You need the ZT100. Keep up with fast print speeds, crisp print quality, an all-metal frame and security.",
    image:img10
  },
  {
    id:3,
    category:"PX45 - Honeywell",
    description:"The PX45 Series industrial printers are flexible, compact, and enabling customers to optimize their printing operations, and achieve quick return on investment.",
    image:img11
  },
]
  return (
    <div>
      <section>
    <Container className="py-5">
      <h2 className="mb-4 cijh2">Desktop Printers</h2>
      <Row>
        {productDesktop.map(product => (
          <Col lg={4} md={6} className="mb-4" key={product.id}>
            <Card className="h-100 border-light shadow-sm rounded-3">
              <div className="p-3 text-center">
                <img src={product.image} alt={product.model} className="img-fluid" style={{ maxHeight: '200px' }} onLoad={lazy} />
              </div>
              <Card.Body className="d-flex flex-column">
                <div className=" mb-2" 
                style={{
                  background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  fontFamily:"Poppins",
                  color: "transparent",
                  fontWeight :"bold",
                  display: "inline-flex",
                  alignItems: "center",
                  textDecoration: "none",
                  marginTop: "auto",
                }}>
                  {product.category}</div>
                
                <p className="text-muted" style={{fontFamily:"sans-serif"}}>{product.description}</p>
                
                <Link to={product.productlink}>
                <button 
                  className={`zartec-btn zartec-btn-primary zartec-btn-small`} 
                  
                  >
                  Get Product
                  </button>
                  </Link>
              </Card.Body>
              
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
    </section>

    <section>
    <Container className="py-5">
      <h2 className="mb-4 cijh2">Mobile Printers</h2>
      <Row>
        {productMobile.map(product => (
          <Col lg={4} md={6} className="mb-4" key={product.id}>
            <Card className="h-100 border-light shadow-sm rounded-3">
              <div className="p-3 text-center">
                <img src={product.image} alt={product.model} className="img-fluid" style={{ maxHeight: '200px' }} />
              </div>
              <Card.Body className="d-flex flex-column">
                <div className=" mb-2" 
                style={{
                  background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  fontFamily:"Poppins",
                  color: "transparent",
                  fontWeight :"bold",
                  display: "inline-flex",
                  alignItems: "center",
                  textDecoration: "none",
                  marginTop: "auto",
                }}>
                  {product.category}</div>
                
                <p className="text-muted" style={{fontFamily:"sans-serif"}}>{product.description}</p>
                
                <Link to={product.productlink}>
                <button 
                  className={`zartec-btn zartec-btn-primary zartec-btn-small`} 
                  
                  >
                  Get Product
                  </button>
                  </Link>
              </Card.Body>
              
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
    </section>

    <section>
    <Container className="py-5">
      <h2 className="mb-4 cijh2">Industrial Printers</h2>
      <Row>
        {productIndustrial.map(product => (
          <Col lg={4} md={6} className="mb-4" key={product.id}>
            <Card className="h-100 border-light shadow-sm rounded-3">
              <div className="p-3 text-center">
                <img src={product.image} alt={product.model} className="img-fluid" style={{ maxHeight: '200px' }} />
              </div>
              <Card.Body className="d-flex flex-column">
                <div className=" mb-2" 
                style={{
                  background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  fontFamily:"Poppins",
                  color: "transparent",
                  fontWeight :"bold",
                  display: "inline-flex",
                  alignItems: "center",
                  textDecoration: "none",
                  marginTop: "auto",
                }}>
                  {product.category}</div>
                
                <p className="text-muted" style={{fontFamily:"sans-serif"}}>{product.description}</p>
                
                <Link to={product.productlink}>
                <button 
                  className={`zartec-btn zartec-btn-primary zartec-btn-small`} 
                  
                  >
                  Get Product
                  </button>
                  </Link>
              </Card.Body>
              
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
    </section>
    </div>
  )
}

export default BarcodePrinters
